import { apiClient } from './api'

/**
 * 无差旅预算部门编号黑名单 - 模块级 Promise 单例缓存
 *
 * 设计：
 *   - 启动后基本不变（Apollo 配置动态更新需用户刷新页面），无需订阅刷新
 *   - 接口失败 fail-open，返回空 Set，主流程不被阻断
 *   - 多组件并发调用时共享同一个 Promise，避免重复请求
 */
let cache: Promise<Set<string>> | null = null

export function loadNoBudgetDepartments(): Promise<Set<string>> {
  if (!cache) {
    cache = apiClient
      .getNoBudgetDepartments()
      .then((list) => new Set(list))
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[noBudgetDepartmentCache] 加载失败，降级为空集合:', err)
        // 失败时保留已 resolve 的 empty Set（不重置 cache），避免接口抖动时
        // 多个并发渲染周期反复触发新请求（thundering herd）。
        // 需要重试时调用 resetNoBudgetDepartmentsCache() 后刷新页面即可。
        return new Set<string>()
      })
  }
  return cache
}

/** 手动清空缓存（测试/管理员配置变更后调用） */
export function resetNoBudgetDepartmentsCache(): void {
  cache = null
}
